var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consulting-operation"},[_c('div',{staticClass:"operation-container"},[_c('el-button',{staticClass:"update-button",attrs:{"type":"primary","size":"large","loading":_vm.loading},on:{"click":_vm.handleUpdateAllPrices}},[_vm._v(" 更新所有人价格 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }